// @ts-ignore -- JavaScript module has no TypeScript declaration yet.
import { Media } from '../../../../components/Media.js';
import classNames from 'classnames';
import type { SignupMediaPanelProps } from './SignupMediaPanel';

export function SignupMediaPanelNormal({
  mediaContent,
  activeIndex,
}: SignupMediaPanelProps) {
  const isCompletionStep = activeIndex === 4;
  const content = mediaContent.Content ?? '';
  const hasMobileMedia = !!mediaContent.MobileMedia?.Image;
  const hasDesktopMedia = !!mediaContent.Media?.Image;
  const showContent = !!content;
  const showMobileMedia = hasMobileMedia;

  const containerClass = classNames(
    'relative top-0 max-xl:h-[400px] flex flex-col justify-between w-full xl:w-1/2',
    {
      'xl:sticky xl:top-[64px] max-h-[calc(100dvh-64px)]': true,
      'xl:hidden': isCompletionStep,
    },
  );

  return (
    <div className={containerClass}>
      {showContent && (
        <div
          className="_rte absolute inset-0 z-10 px-12 py-8 md:py-10 lg:py-20 font-light text-white text-center space-y-3 lg:space-y-4 [&_h2]:mb-0 [&_h3]:mb-0 max-lg:[&_h2]:text-3xl max-lg:[&_h3]:text-2xl [&_ul]:flex [&_ul]:flex-wrap [&_ul]:justify-center [&_ul]:items-center [&_ul]:gap-x-6 [&_ul]:p-0 [&_li]:list-none [&_li]:p-0"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
      {showMobileMedia && (
        <figure
          className={classNames(
            'relative w-full block max-xl:h-[400px] xl:h-full',
            {
              'xl:hidden': hasDesktopMedia,
            },
          )}
        >
          <Media umbraco={mediaContent} media={mediaContent.MobileMedia} />
        </figure>
      )}
      {hasDesktopMedia && (
        <figure
          className={classNames(
            'relative w-full block max-xl:h-[400px] xl:h-full',
            {
              'max-xl:hidden': showMobileMedia,
            },
          )}
        >
          <Media umbraco={mediaContent} media={mediaContent.Media} />
        </figure>
      )}
    </div>
  );
}
